import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useAuth as useHelpdeskAuth } from '../../../contexts/AuthContext';
import { camasirhaneApi } from '../../../api/camasirhaneApi';

const CamasirhaneRoleContext = createContext(null);

export function CamasirhaneRoleProvider({ children }) {
  const { user: helpdeskUser, isAuthenticated } = useHelpdeskAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      setProfile(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    camasirhaneApi
      .getMe()
      .then((data) => setProfile(data))
      .catch(() => setProfile(null))
      .finally(() => setLoading(false));
  }, [isAuthenticated, helpdeskUser?.id]);

  const user = useMemo(() => {
    if (!profile) return null;
    return {
      ...profile,
      username: profile.email,
    };
  }, [profile]);

  const value = useMemo(
    () => ({ user, loading, refresh: () => camasirhaneApi.getMe().then(setProfile) }),
    [user, loading]
  );

  return (
    <CamasirhaneRoleContext.Provider value={value}>
      {children}
    </CamasirhaneRoleContext.Provider>
  );
}

export function useCamasirhaneRole() {
  const context = useContext(CamasirhaneRoleContext);
  if (!context) {
    throw new Error('useCamasirhaneRole must be used within CamasirhaneRoleProvider');
  }
  return context;
}

/** Prototip ekranlarıyla uyumluluk için alias */
export function useAuth() {
  return useCamasirhaneRole();
}
